<template>
  <svg class="lds-spin" :visibility="[visible ? 'visible' : 'hidden']" :width="width"  :height="width" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;"><g transform="translate(80,50)">
    <title id="title" lang="PT-BR">{{alt}}</title>
    <g transform="rotate(0)">
      <circle cx="0" cy="0" r="8" :fill="fill" fill-opacity="1" transform="scale(1.04309 1.04309)">
        <animateTransform attributeName="transform" type="scale" begin="-0.525s"
                          values="1.1 1.1;1 1" keyTimes="0;1"
                          dur="0.6s" repeatCount="indefinite"></animateTransform>
        <animate attributeName="fill-opacity" keyTimes="0;1" dur="0.6s"
                 repeatCount="indefinite" values="1;0" begin="-0.525s"></animate>
      </circle>
    </g>
  </g><g transform="translate(71.21320343559643,71.21320343559643)">
    <g transform="rotate(45)">
      <circle cx="0" cy="0" r="8" :fill="fill" fill-opacity="0.875"
              transform="scale(1.05559 1.05559)">
        <animateTransform attributeName="transform" type="scale" begin="-0.44999999999999996s"
                          values="1.1 1.1;1 1" keyTimes="0;1"
                          dur="0.6s" repeatCount="indefinite"></animateTransform>
        <animate attributeName="fill-opacity" keyTimes="0;1" dur="0.6s" repeatCount="indefinite"
                 values="1;0" begin="-0.44999999999999996s"></animate>
      </circle>
    </g>
  </g><g transform="translate(50,80)">
    <g transform="rotate(90)">
      <circle cx="0" cy="0" r="8" :fill="fill" fill-opacity="0.75"
              transform="scale(1.06809 1.06809)">
        <animateTransform attributeName="transform" type="scale" begin="-0.375s"
                          values="1.1 1.1;1 1" keyTimes="0;1"
                          dur="0.6s" repeatCount="indefinite"></animateTransform>
        <animate attributeName="fill-opacity" keyTimes="0;1" dur="0.6s" repeatCount="indefinite"
                 values="1;0" begin="-0.375s"></animate>
      </circle>
    </g>
  </g><g transform="translate(28.786796564403577,71.21320343559643)">
    <g transform="rotate(135)">
      <circle cx="0" cy="0" r="8" :fill="fill" fill-opacity="0.625"
              transform="scale(1.08059 1.08059)">
        <animateTransform attributeName="transform" type="scale" begin="-0.3s"
                          values="1.1 1.1;1 1" keyTimes="0;1"
                          dur="0.6s" repeatCount="indefinite"></animateTransform>
        <animate attributeName="fill-opacity" keyTimes="0;1" dur="0.6s" repeatCount="indefinite"
                 values="1;0" begin="-0.3s"></animate>
      </circle>
    </g>
  </g><g transform="translate(20,50.00000000000001)">
    <g transform="rotate(180)">
      <circle cx="0" cy="0" r="8" :fill="fill"
              fill-opacity="0.5" transform="scale(1.09309 1.09309)">
        <animateTransform attributeName="transform" type="scale" begin="-0.22499999999999998s"
                          values="1.1 1.1;1 1" keyTimes="0;1"
                          dur="0.6s" repeatCount="indefinite"></animateTransform>
        <animate attributeName="fill-opacity" keyTimes="0;1" dur="0.6s" repeatCount="indefinite"
                 values="1;0" begin="-0.22499999999999998s"></animate>
      </circle>
    </g>
  </g><g transform="translate(28.78679656440357,28.786796564403577)">
    <g transform="rotate(225)">
      <circle cx="0" cy="0" r="8" :fill="fill" fill-opacity="0.375"
              transform="scale(1.00559 1.00559)">
        <animateTransform attributeName="transform" type="scale" begin="-0.15s" values="1.1 1.1;1 1"
                          keyTimes="0;1" dur="0.6s" repeatCount="indefinite"></animateTransform>
        <animate attributeName="fill-opacity" keyTimes="0;1" dur="0.6s" repeatCount="indefinite"
                 values="1;0" begin="-0.15s"></animate>
      </circle>
    </g>
  </g><g transform="translate(49.99999999999999,20)">
    <g transform="rotate(270)">
      <circle cx="0" cy="0" r="8" :fill="fill" fill-opacity="0.25"
              transform="scale(1.01809 1.01809)">
        <animateTransform attributeName="transform" type="scale" begin="-0.075s"
                          values="1.1 1.1;1 1" keyTimes="0;1"
                          dur="0.6s" repeatCount="indefinite"></animateTransform>
        <animate attributeName="fill-opacity" keyTimes="0;1" dur="0.6s" repeatCount="indefinite"
                 values="1;0" begin="-0.075s"></animate>
      </circle>
    </g>
  </g><g transform="translate(71.21320343559643,28.78679656440357)">
    <g transform="rotate(315)">
      <circle cx="0" cy="0" r="8" :fill="fill" fill-opacity="0.125"
              transform="scale(1.03059 1.03059)">
        <animateTransform attributeName="transform" type="scale" begin="0s" values="1.1 1.1;1 1"
                          keyTimes="0;1" dur="0.6s" repeatCount="indefinite"></animateTransform>
        <animate attributeName="fill-opacity" keyTimes="0;1" dur="0.6s" repeatCount="indefinite"
                 values="1;0" begin="0s"></animate>
      </circle>
    </g>
  </g></svg>
</template>

<script>
export default {
  name: 'Loader.vue',
  props: {
    width: {
      type: Number,
      default: 62,
      required: false,
    },
    fill: {
      type: String,
      default: '#e38931',
      required: false,
    },
    alt: {
      type: String,
      default: 'Carregando...',
      required: false,
    },
    visible: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<style scoped>

</style>
